import { Injectable } from '@angular/core';
import { ICacheService } from './icache.service';
import { PlatformService } from '../platform/platform.service';
import { UtilService } from '../util/util.service';
import { LocalStorageService } from '../storage/local-storage.service';

@Injectable()
export class CacheService implements ICacheService {
  public _platformService: PlatformService;
  public _localStorageService: LocalStorageService;
  public _utilService: UtilService;

  public constructor(utilService: UtilService, localStorageService: LocalStorageService, platformService: PlatformService) {
    this._platformService = platformService;
    this._utilService = utilService;
    this._localStorageService = localStorageService;
  }

  public updateApplicationCodeCacheIfNecessary = (): void => {
    var wlVersionKeyName = 'wlVersion';
    var lastWlVersionStored = this._localStorageService.getNumber(wlVersionKeyName);
    if (this._utilService.isNullOrLessThanOrEqualToZero(lastWlVersionStored)) {
      lastWlVersionStored = 0;
    }

    //this global platform variable is set in the index.html file
    //before systemjs loads our app
    let latestVersion: any = this._platformService.getPlatformGlobalVariable(wlVersionKeyName);
    if (this._utilService.isNullOrLessThanOrEqualToZero(latestVersion)) {
      latestVersion = 1;
    }

    if (latestVersion != lastWlVersionStored) {
      //update the last retrieved version
      localStorage.setItem(wlVersionKeyName, latestVersion);
      //Now get the newer version
      //to force getting of new html templates
      //per Angular2 docs this will force refresh of css and .html templates
      this._platformService.clearPlatformCache();
      //js files will be relaoded with code in
      //systemjs.config.js where we override System.locate to append a version qs param
    }
  };
}
